import {
  configure,
  hitsPerPage,
  index,
} from "instantsearch.js/es/widgets/index.js";
import {
  createCustomLabels,
  createNewSearchInstance,
  createTableColumns,
  renderFilters,
} from "./components/index.js";
import { filterAssignments } from "./facets.js";
import {
  chamfrColumnConfigMiddleware,
  chamfrOutOfStockMiddleware,
  chamfrLoadingSkeletonMiddleware,
} from "./middleware/index.js";
import {
  chamfrClearAllFilters,
  chamfrPagination,
  chamfrProductsHits,
  chamfrProductsSortBy,
  chamfrResultsHeader,
  chamfrSearchBox,
  chamfrSelectedFilters,
} from "./widgets/index.js";

export const initializeRecentlyAddedProducts = (element) => {
  const recentTs = algolia.recent_products_ts || 0;
  const setup = filterAssignments["RECENT"];

  const columns = [
    ...(setup.displayHits || []),
    ...filterAssignments["EVERY"].displayHits,
    ...filterAssignments["DEFAULT"].displayHits,
  ].sort((a, b) => a.orderColumns - b.orderColumns);

  const filters = [...(setup.displayFacets || [])].sort(
    (a, b) => a.orderFacets - b.orderFacets
  );

  const search = createNewSearchInstance();
  search.use(chamfrOutOfStockMiddleware);
  search.use(chamfrLoadingSkeletonMiddleware);
  search.use(chamfrColumnConfigMiddleware());

  const products = index({
    indexName: `${algolia.product_index_name}_created_ts_desc`,
    indexId: "products",
  });

  const widgets = [
    configure({
      getRankingInfo: true,
      clickAnalytics: true,
      filters: `created_ts > ${recentTs}`,
    }),
    chamfrSearchBox({
      container: element.querySelector(".search-form"),
      label: "Search within these results",
    }),
    chamfrResultsHeader({
      container: element.querySelector(".results-header"),
    }),
    hitsPerPage({
      container: element.querySelector(".display-per-page span"),
      items: [
        { label: "50 Items", value: 50, default: true },
        { label: "100 Items", value: 100 },
        { label: "250 Items", value: 250 },
      ],
    }),
    chamfrPagination({
      container: element.querySelector(".chamfr-pagination"),
    }),
    chamfrClearAllFilters({
      container: element.querySelector(".selected-filters .clear-all-filters"),
    }),
  ];

  const filtersContainer = element.querySelector(".search-results-leftside");

  const customLabels = createCustomLabels(filters);
  const tableColumns = createTableColumns(columns);

  widgets.push(...renderFilters(filters, filtersContainer, element));

  widgets.push(
    chamfrSelectedFilters({
      container: element.querySelector(".selected-filters ul"),
      customLabels: Object.fromEntries(customLabels),
    })
  );

  widgets.push(
    chamfrProductsSortBy({
      container: element.querySelector("table.products .header"),
      items: [],
      defaultIndex: `${algolia.product_index_name}_created_ts_desc`,
      columns: tableColumns,
    })
  );

  widgets.push(
    chamfrProductsHits({
      container: element.querySelector("table.products .list"),
      columns: tableColumns,
    })
  );

  products.addWidgets(widgets);

  search.addWidgets([products]);

  search.start();
};
